const getStatusStyles = (status?: string) => {
  const normalizedStatus = status?.trim().toLowerCase();

  const styles: Record<string, string> = {
    active: "bg-emerald-100 text-green-600 border border-emerald-200",
    expired: "bg-red-100 text-red-700 border border-red-200",

    paid: "bg-green-100 text-green-600 border border-green-200",
    unbilled: "bg-yellow-100 text-yellow-600 border border-yellow-200",
    reconciled: "bg-purple-100 text-purple-600 border border-purple-200",
    invoiced: "bg-blue-100 text-blue-600 border border-blue-200",

    healthy: "bg-green-100 text-green-700 border border-green-200",
    degraded: "bg-yellow-100 text-yellow-700 border border-yellow-200",
    down: "bg-red-100 text-red-700 border border-red-200",

    draft: "bg-gray-100 text-gray-600 border border-gray-200",
    submitted: "bg-blue-100 text-blue-700 border border-blue-200",
    "under review": "bg-amber-100 text-amber-700 border border-amber-200",
    "sent back": "bg-amber-100 text-amber-700 border border-amber-200",
    approved: "bg-green-100 text-green-600 border border-green-200",
    suspended: "bg-red-100 text-red-700 border border-red-200",
    rejected: "bg-red-100 text-red-700 border border-red-200",

    pending: "bg-gray-100 text-gray-600 border border-gray-200",
    verified: "bg-green-100 text-green-600 border border-green-200",
  };

  return styles[normalizedStatus || ""] || "";
};

export const Status = ({ status }: { status?: string }) => {
  return (
    <span
      className={`px-2 py-0.5 text-[10px] font-bold rounded-2xl uppercase tracking-wider ${getStatusStyles(
        status
      )}`}
    >
      {status?.toUpperCase() || "-"}
    </span>
  );
};
